import { render } from "./i-file.vue?vue&type=template&id=d87c9ef8&scoped=true"
import script from "./i-file.vue?vue&type=script&lang=js"
export * from "./i-file.vue?vue&type=script&lang=js"

import "./i-file.vue?vue&type=style&index=0&id=d87c9ef8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d87c9ef8"]])

export default __exports__